/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import NewsletterModel, { SendStateType } from 'cio/models/newsletter';

export const STATE_TO_TAG_MAP: Record<SendStateType, { label: string; class: string; tooltipContent: string }> = {
  drafted: {
    label: 'Draft',
    class: 'is-pending',
    tooltipContent: 'Not yet sending messages',
  },
  scheduled: {
    label: 'Scheduled',
    class: 'is-pending',
    tooltipContent: 'Newsletter is scheduled to send in the future',
  },
  sending: {
    label: 'Sending',
    class: 'is-success',
    tooltipContent: 'Newsletter is actively sending to each recipient of the newsletter',
  },
  sent: {
    label: 'Sent',
    class: 'is-success',
    tooltipContent: 'Newsletter has finished sending to all recipients of the newsletter',
  },
  stopped: {
    label: 'Stopped',
    class: 'is-pending',
    tooltipContent: "Newsletter is stopped and won't send any more messages",
  },
};

type NewsletterStateTagArgs = {
  newsletter: NewsletterModel;
};

export default class NewsletterStateTag extends Component<NewsletterStateTagArgs> {
  get newsletterState() {
    return STATE_TO_TAG_MAP[this.args.newsletter.sendState];
  }
}
